export default __webpack_public_path__ + "static/media/eq.b58a6341.png";